export default __webpack_public_path__ + "static/media/45.bd19de08.svg";